import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { DEADLINE_REPORT_QUERY } from '../../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData } from '../CustomUtils.js'

const DEADLINE_REPORT = gql(DEADLINE_REPORT_QUERY)

export default function DeadlineReport({ location }) {
  console.log('DeadlineReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const reportGroup = params.get('in_group')
    getData(null, DEADLINE_REPORT, 'deadlineReport', setResults, setGraphQLErrors, 'reportGroup', reportGroup)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        <div dangerouslySetInnerHTML={{ __html: results }} />
      </div>
    )
  }
}
